/**
 * Médias de scène (voix MP3, vidéo de la voix IA) téléchargés EN ENTIER dès
 * l'ouverture de la conférence, puis lus depuis la mémoire.
 *
 * ⚠️ POURQUOI. Un `<audio>` ou un `<video>` à qui l'on donne une URL au moment
 * du F1 ouvre la connexion à cet instant, revalide le fichier (Vercel sert
 * `max-age=0, must-revalidate`), puis le lit par requêtes de plages
 * successives : démarrage lent et saccades, même en fibre. Le serveur n'y est
 * pour rien (la vidéo de 3 Mo est livrée en 0,3 s, mesuré le 28/09) : c'est le
 * lecteur qui attend ses morceaux. Une URL `blob:` n'a plus aucun réseau
 * derrière elle.
 *
 * Le cache vit avec l'onglet, sans révocation : quelques Mo au total, et une
 * URL révoquée pendant une répétition (remontage de la page) donnerait un
 * média muet. Si le téléchargement n'a pas abouti au moment de la lecture,
 * `versionLocale` rend l'URL d'origine : comportement d'avant, rien de cassé.
 */

const enMemoire = new Map(); // URL publique -> URL blob:
const enCours = new Map(); // URL publique -> Promise

export const prechargerMedia = (url) => {
    if (!url || enMemoire.has(url)) return Promise.resolve();
    if (enCours.has(url)) return enCours.get(url);
    // Les médias sont servis par le front (`public/`) : même origine, donc ni
    // CORS ni graphe Web Audio « souillé » pour l'orbe.
    const tache = fetch(`${process.env.PUBLIC_URL || ''}${url}`)
        .then((r) => (r.ok ? r.blob() : Promise.reject(new Error(`HTTP ${r.status}`))))
        .then((blob) => { enMemoire.set(url, URL.createObjectURL(blob)); })
        .catch(() => { /* repli : lecture depuis le réseau */ })
        .finally(() => enCours.delete(url));
    enCours.set(url, tache);
    return tache;
};

export const versionLocale = (url) => enMemoire.get(url) || url;
